import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AccountAutocomplete, AccountSearchField, UserRole } from '@shared/definitions';

@Injectable({
  providedIn: 'root',
})
export class UsersApiService {
  constructor(private http: HttpClient) {}

  getUserRoles = () => this.http.get<UserRole[]>('/api/v1.0/users/roles');

  /** Account autocomplete for staff surfaces (PAUL-3595) — bare array, max 10, `[]` under 2 characters. `X-Company-Id` narrows it to the active company. */
  searchAccounts = (search: string, field: AccountSearchField) =>
    this.http.get<AccountAutocomplete[]>('/api/v1.0/accounts/autocomplete', { params: { search, field } });
}
